export default __webpack_public_path__ + "static/media/swiperush-logo.11054e9d.png";